// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import switchHorizontal01Icon from "@/assets/icons/switch-horizontal-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SwitchHorizontal01IconProps = Omit<IconProps, "name">;

export function SwitchHorizontal01Icon(props: SwitchHorizontal01IconProps): React.ReactNode {
  return <Icon name={switchHorizontal01Icon} {...props} />;
}
